// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__rUOTV","balanceDisclaimer":"posDashboard_balanceDisclaimer__1guO_"};